import { gql } from '@apollo/client'

export const GET_LOYALTY_CAMPAIGN_COMPANY = gql`
  query GetLoyaltyCampaign($campaignId: ID!) {
    loyaltyCampaign(input: { id: $campaignId }) {
      startAt
      company {
        id
      }
      companyLines {
        id
        name
      }
    }
  }
`
export const CREATE_LOYALTY_CAMPAIGN_RULE = gql`
  mutation CreateLoyaltyCampaignRule(
    $ruleHowToGetIt: String!
    $ruleName: String!
    $ruleValidAt: String!
    $ruleDescription: String
    $ruleDetails: String!
    $ruleConditions: CreateLoyaltyCampaignRuleConditionsInput!
    $ruleEffects: CreateLoyaltyCampaignRuleEffectsInput!
    $campaignId: ID!
  ) {
    createLoyaltyCampaignRule(
      input: {
        howToGet: $ruleHowToGetIt
        name: $ruleName
        validAt: $ruleValidAt
        description: $ruleDescription
        details: $ruleDetails
        conditions: $ruleConditions
        effects: $ruleEffects
        id: $campaignId
      }
    )
  }
`
